module.exports = __webpack_public_path__ + "img/boda-baile-thumbnail.51383135.jpg";